<label class="search">
  <i class="bi bi-search search-icon" aria-hidden="true"></i>
  <input
    type="search"
    [value]="value()"
    [placeholder]="placeholder()"
    [attr.aria-label]="ariaLabel()"
    (input)="onInput($event)"
    (keydown.escape)="clear()"
  />
  @if (value()) {
    <button
      type="button"
      class="clear"
      aria-label="Clear search"
      (click)="clear()"
    >
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
  }
</label>
